import { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'

const proptypes = {
  text: PropTypes.string.isRequired,
  updateStep: PropTypes.func.isRequired,
  active: PropTypes.bool,
  alreadyComplete: PropTypes.bool,
  openMobileDevice: PropTypes.func,
  lastStep: PropTypes.bool
}

const Container = styled.li`
  border: 1px solid
    ${(props) => (props.active ? 'var(--main-color)' : 'var(--light-gray)')};
  margin-bottom: 15px;
  border-radius: 18px;
  cursor: pointer;
  position: relative;
  font-weight: 600;
  padding: 7px;
  margin-right: 10px;
  margin-top: 20px;
`

const Circle = styled.div`
  width: 35px;
  height: 35px;
  background: #fff;
  border: 1px solid var(--main-color);
  border-radius: 50px;
  text-align: center;
  color: #8d8d8d;
  font-size: 18px;
  padding: 3px 0px 0px 0px;
  margin-right: 20px;
  top: -1px;
  left: -1px;
  position: absolute;
  background-color: ${(props) =>
    props.active ? 'var(--main-color)' : 'var(--white)'};
  color: ${(props) => (props.active ? 'var(--white)' : 'var(--main-color)')};
`

const Content = styled.div`
  margin-left: 50px;
`
class TutorialStep extends Component {
  constructor(props) {
    super(props)
    this.tutorialUpdateStep = this.tutorialUpdateStep.bind(this)
  }

  tutorialUpdateStep(step) {
    this.props.createUserEvent({
      category: 'tutorials',
      data: {
        action: 'OnStepTextClick',
        target: this.props.currentTutorialId,
        step_to: step
      }
    })
    this.props.updateStep(step)
  }

  render() {
    const { text, active, alreadyComplete, stepNum, stepArrayLoc } = this.props

    const activeOrComplete = active || alreadyComplete

    return (
      <Container
        active={activeOrComplete}
        id={active ? 'step-active' : ''}
        onClick={this.tutorialUpdateStep.bind(this, stepArrayLoc)}
      >
        <div className="clearfix">
          <Circle active={activeOrComplete}>{stepNum}</Circle>
          <Content
            className="listItemText"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </div>
      </Container>
    )
  }
}

TutorialStep.propTypes = proptypes

export default LanguageProvider(TutorialStep)
